import { render, staticRenderFns } from "./AppOverlay.vue?vue&type=template&id=61d5aed2&"
import script from "./AppOverlay.vue?vue&type=script&lang=js&"
export * from "./AppOverlay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports